import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './dashboard.jsx';

/** Map KPI perm.buFilter → danh sách BU tab trong bu-perf. */
export function visibleBUsFromPerm(perm) {
  const f = perm && perm.buFilter;
  if (f === 'CAR') return ['Car'];
  if (f === 'HJ') return ['Heli', 'Jet'];
  if (f === 'MKT') return ['Heli', 'Car', 'Jet']; // MKT xem cross-BU sales/mkt
  // COO / null / All
  return ['Heli', 'Car', 'Jet'];
}

let _root = null;
let _el = null;

/**
 * Mount BU Performance React app vào container.
 * Gọi lại an toàn khi đổi role — remount với props mới.
 */
export function mountBuPerf(el, opts = {}) {
  if (!el) return;
  const props = {
    embedded: true,
    visibleBUs: opts.visibleBUs || ['Heli', 'Car', 'Jet'],
    initialBU: opts.initialBU,
  };
  if (_root && _el === el) {
    _root.render(<App {...props} />);
    return;
  }
  if (_root) {
    try { _root.unmount(); } catch {}
    _root = null;
  }
  _el = el;
  _root = createRoot(el);
  _root.render(<App {...props} />);
}

export function unmountBuPerf() {
  if (_root) {
    try { _root.unmount(); } catch {}
    _root = null;
    _el = null;
  }
}
